module.exports = __webpack_public_path__ + "img/systemIcon.d41a2274.png";